export default __webpack_public_path__ + "static/media/calorie.25fef86e.svg";